import React from 'react';
import { Button } from 'reactstrap';
import { Plus, Trash2, Info } from 'react-feather';

import { INPUT_COLUMNS, EMPTY_ROW, MAX_LIMIT, SEARCH_HINT } from '../searchScrape.constants';
import { buildQuery } from '../searchScrape.queryBuilder';

// Editable grid: Limit, Search. A live Serpix-query preview sits under each row.
export default function ManualEntryTable({ rows, onChange, disabled }) {
  const updateCell = (index, key, value) => {
    onChange(rows.map((row, i) => (i === index ? { ...row, [key]: value } : row)));
  };
  const addRow = () => onChange([...rows, { ...EMPTY_ROW }]);
  const removeRow = (index) => {
    const next = rows.filter((_, i) => i !== index);
    onChange(next.length ? next : [{ ...EMPTY_ROW }]);
  };

  return (
    <div>
      <div className="table-responsive">
        <table className="table table-bordered align-middle mb-2" style={{ maxWidth: 760 }}>
          <thead className="table-light">
            <tr>
              <th style={{ width: 36 }}>#</th>
              {INPUT_COLUMNS.map((col) => (
                <th key={col.key} style={{ width: col.width, minWidth: col.width }} title={col.help}>
                  {col.label}
                </th>
              ))}
              <th style={{ width: 44 }} />
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => {
              const preview = buildQuery(row);
              return (
                <React.Fragment key={index}>
                  <tr>
                    <td className="text-muted">{index + 1}</td>
                    {INPUT_COLUMNS.map((col) => (
                      <td key={col.key}>
                        <input
                          type={col.type === 'number' ? 'number' : 'text'}
                          className="form-control form-control-sm"
                          placeholder={col.placeholder}
                          value={row[col.key] || ''}
                          min={col.type === 'number' ? 1 : undefined}
                          max={col.key === 'limit' ? MAX_LIMIT : undefined}
                          onChange={(e) => updateCell(index, col.key, e.target.value)}
                          disabled={disabled}
                        />
                      </td>
                    ))}
                    <td className="text-center">
                      <Button color="link" className="p-0 text-danger" onClick={() => removeRow(index)} disabled={disabled} title="Remove row">
                        <Trash2 size={16} />
                      </Button>
                    </td>
                  </tr>
                  <tr>
                    <td />
                    <td colSpan={INPUT_COLUMNS.length + 1} className="py-1">
                      <small className="text-muted">
                        <span className="fw-bold">Serpix query (google_search): </span>
                        {preview ? <code className="text-primary">{preview}</code> : <span className="fst-italic">add a search string</span>}
                      </small>
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <Button color="outline-primary" size="sm" onClick={addRow} disabled={disabled}>
          <Plus size={15} className="me-1" />
          Add Row
        </Button>
        <small className="text-muted ms-2">
          <Info size={13} className="me-1" />{SEARCH_HINT}
        </small>
      </div>
    </div>
  );
}
